<!-- Wrapper con scroll -->
<div style="max-height: 65vh; overflow-y: auto; padding-right: 0.25rem;">

<div class="form-header" style="margin-bottom: 1.5rem;">
  <h3 class="form-title" style="font-size: 1.5rem; margin-bottom: 0.5rem;">Verificar Código</h3>
  <p class="form-subtitle" style="font-size: 0.9375rem;">
    {{ twoFactorMethod === 'sms' ? 'Ingresa el código enviado a tu teléfono' : 'Ingresa el código de tu app de autenticación' }}
  </p>
</div>

<!-- Info -->
<div style="background: #ecfdf5; border: 1px solid #a7f3d0; border-radius: 8px; padding: 1rem; margin-bottom: 1.5rem;">
  <div style="display: flex; gap: 0.625rem; align-items: start;">
    <i class="fas" [class.fa-mobile-alt]="twoFactorMethod === 'sms'" [class.fa-shield-alt]="twoFactorMethod === 'authenticator'" style="color: #059669; font-size: 1rem; margin-top: 0.125rem;"></i>
    <div style="flex: 1;">
      <p style="font-size: 0.875rem; color: #047857; margin: 0; line-height: 1.4;">
        <ng-container *ngIf="twoFactorMethod === 'sms'">
          Hemos enviado un código de 6 dígitos al número <strong>{{ phoneNumber }}</strong>
        </ng-container>
        <ng-container *ngIf="twoFactorMethod === 'authenticator' && !useBackupCode">
          Ingresa el código de 6 dígitos de tu app de autenticación
        </ng-container>
        <ng-container *ngIf="twoFactorMethod === 'authenticator' && useBackupCode">
          Ingresa tu código de respaldo (Formato: XXXX-XXXX)
        </ng-container>
      </p>
    </div>
  </div>
</div>

<!-- Error Messages -->
<div *ngIf="errors && errors.length > 0" class="error-container" style="margin-bottom: 1.5rem;">
  <div class="error-alert" *ngFor="let error of errors" style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 1rem; display: flex; gap: 0.625rem; align-items: start;">
    <i class="fas fa-exclamation-triangle" style="color: #dc2626; margin-top: 0.125rem;"></i>
    <span style="color: #991b1b; font-size: 0.875rem;">{{ error.msg }}</span>
  </div>
</div>

<!-- Form -->
<form [formGroup]="form" (ngSubmit)="submit()" class="auth-form" style="margin-bottom: 1.5rem;">
  <div class="input-group" style="margin-bottom: 1.25rem;">
    <label for="code" class="input-label" style="font-size: 0.9375rem; margin-bottom: 0.625rem;">Código</label>
    <input type="text" id="code" formControlName="code" (input)="formatInput($event)" [placeholder]="useBackupCode ? 'XXXX-XXXX' : '000000'" [maxlength]="useBackupCode ? 9 : 6" class="auth-input" [class.error]="form.get('code')?.invalid && form.get('code')?.touched" style="text-align: center; font-size: 1.75rem; font-weight: 700; letter-spacing: 0.5rem; font-family: monospace; padding: 1rem; border: 2px solid #e5e7eb; border-radius: 8px; width: 100%;">
    <div *ngIf="form.get('code')?.invalid && form.get('code')?.touched" class="input-error" style="margin-top: 0.5rem;">
      <i class="fas fa-exclamation-circle"></i>
      <span *ngIf="form.get('code')?.errors?.['required']">Campo requerido</span>
      <span *ngIf="form.get('code')?.errors?.['pattern']">{{ useBackupCode ? 'Formato: XXXX-XXXX' : 'Debe ser 6 dígitos' }}</span>
    </div>
  </div>

  <!-- Toggle (solo para Authenticator) -->
  <div *ngIf="twoFactorMethod === 'authenticator'" style="text-align: center; margin-bottom: 1.5rem;">
    <button type="button" (click)="toggleBackupCode()" style="background: none; border: none; color: #01abce; font-size: 0.875rem; font-weight: 600; cursor: pointer; padding: 0.625rem 1rem; border-radius: 6px; transition: background 0.2s;" onmouseover="this.style.backgroundColor='rgba(1, 171, 206, 0.1)'" onmouseout="this.style.backgroundColor='transparent'">
      <i class="fas" [class.fa-mobile-alt]="useBackupCode" [class.fa-key]="!useBackupCode" style="margin-right: 0.5rem;"></i>
      {{ useBackupCode ? 'Usar código de app' : 'Usar código de respaldo' }}
    </button>
  </div>

  <!-- Botón reenviar (solo para SMS) -->
  <div *ngIf="twoFactorMethod === 'sms'" style="text-align: center; margin-bottom: 1.5rem;">
    <button type="button" (click)="resendSMS()" [disabled]="submit_disabled" style="background: none; border: none; color: #01abce; font-size: 0.875rem; font-weight: 600; cursor: pointer; padding: 0.625rem 1rem; border-radius: 6px; transition: background 0.2s;" onmouseover="if(!this.disabled) this.style.backgroundColor='rgba(1, 171, 206, 0.1)'" onmouseout="this.style.backgroundColor='transparent'">
      <i class="fas fa-redo" style="margin-right: 0.5rem;"></i>
      Reenviar código
    </button>
  </div>

  <!-- Confiar en este dispositivo -->
  <div style="display: flex; align-items: start; gap: 0.75rem; margin-bottom: 1.5rem; padding: 0.875rem; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px;">
    <input type="checkbox" id="trustDevice" [(ngModel)]="trustDevice" [ngModelOptions]="{standalone: true}" style="width: 18px; height: 18px; margin-top: 2px; cursor: pointer; accent-color: #01abce;">
    <label for="trustDevice" style="cursor: pointer; flex: 1;">
      <span style="font-size: 0.875rem; font-weight: 600; color: #1e293b; display: block;">Confiar en este dispositivo</span>
      <span style="font-size: 0.75rem; color: #64748b; line-height: 1.4;">No se te pedirá código de verificación en este navegador durante 30 días</span>
    </label>
  </div>

  <!-- Submit -->
  <button type="submit" [disabled]="!form.valid || submit_disabled" style="width: 100%; background: #01abce; border: 2px solid #01abce; border-radius: 8px; padding: 0.875rem 1.5rem; color: white; font-size: 0.9375rem; font-weight: 600; cursor: pointer; transition: all 0.2s; opacity: 1;" [style.opacity]="!form.valid || submit_disabled ? '0.5' : '1'" [style.cursor]="!form.valid || submit_disabled ? 'not-allowed' : 'pointer'" onmouseover="if(!this.disabled) { this.style.background='#0194b3'; this.style.borderColor='#0194b3'; }" onmouseout="if(!this.disabled) { this.style.background='#01abce'; this.style.borderColor='#01abce'; }">
    <i class="fas" [class.fa-check]="!submit_disabled" [class.fa-spinner]="submit_disabled" [class.fa-spin]="submit_disabled" style="margin-right: 0.5rem;"></i>
    {{ submit_disabled ? 'Verificando...' : 'Verificar' }}
  </button>
</form>

<!-- Footer -->
<div class="form-footer" style="margin-top: 1.5rem;">
  <div style="text-align: center; font-size: 0.875rem; color: #64748b;">
    <i class="fas fa-question-circle" style="margin-right: 0.375rem;"></i> ¿Problemas?
    <button type="button" (click)="cancel()" style="background: none; border: none; color: #01abce; font-weight: 600; cursor: pointer; padding: 0; margin-left: 0.375rem; text-decoration: underline;">Cancelar</button>
  </div>
</div>

</div>
